import { ArrowUpRight } from "lucide-react";
import { site } from "@/config/site.config";

const styles = {
  lime: "bg-lime text-ink hover:bg-cream",
  ghost: "border border-cream/25 text-cream hover:border-lime hover:text-lime",
  dark: "bg-ink text-lime hover:bg-coal",
};

export const CtaButton = ({ id, children, variant = "lime", className = "" }) => (
  <a
    data-testid={`cta-${id}`}
    data-analytics-event="cta_click"
    data-analytics-cta={id}
    href={site.checkoutUrl}
    target="_blank"
    rel="noopener noreferrer"
    className={`group inline-flex min-h-[54px] items-center justify-center gap-2 rounded-full px-7 py-4 font-sans text-sm font-extrabold tracking-[0.08em] transition-colors duration-300 ${styles[variant]} ${className}`}
  >
    <span>{children}</span>
    <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
  </a>
);
